// Polish
export const pl = {
    weeklyRewards: 'Tygodniowe nagrody za',
    days: 'dni',
    hours: 'godz',
    minutes: 'min',
    seconds: 'sek',
    authenticating: 'Uwierzytelnianie',
    verifyWallet: 'Proszę czekać, weryfikujemy Twój portfel',
    authRequired: 'Wymagane uwierzytelnienie',
    authFailed: 'Uwierzytelnienie nie powiodło się. Spróbuj ponownie.',
    points: 'Punkty',
    rank: 'Pozycja',
    of: 'z',
    players: 'graczy',
    weeklyTopPlayers: 'Najlepsi gracze tygodnia',
    thisWeekLeaderboard: 'Ranking tego tygodnia',
    rankingsReset: 'Ranking jest resetowany w każdą niedzielę o północy UTC',
    yourPoints: 'Twoje punkty',
    dailyRewardAvailable: 'Dzienna nagroda dostępna!',
    nextClaimAvailable: 'Następne odebranie dostępne za:',
    claimDailyReward: 'Odbierz dzienną nagrodę',
    claiming: 'Odbieranie...',
    multiplier: 'Mnożnik',
    bonusPointsMultiplier: 'Mnożnik punktów bonusowych',
    outOf: 'z',
    loading: 'Ładowanie...',
    errorLoading: 'Błąd ładowania',
    noEntries: 'Brak wpisów',
    leaderboard: 'Ranking',
    tasks: 'Zadania',
    rules: 'Zasady',
    profile: 'Profil',
    comingSoon: 'Wkrótce...',
    completedTasks: 'Ukończone zadania',
    dailyRewardsClaimed: 'Odebrane nagrody dzienne',
    times: 'razy',
    recentActivity: 'Ostatnia aktywność',
    noRewardsClaimed: 'Nie odebrano jeszcze nagród',
    dailyReward: 'Dzienna nagroda',
    howItWorks: 'Jak to działa',
    welcomeMessage:
        'Witaj w Coinomi Rewards! Zdobywaj punkty wykonując różne zadania i wspinaj się w rankingu.',
    dailyRewardsTitle: 'Nagrody dzienne',
    dailyRewardsRules: [
        'Odbieraj swoją dzienną nagrodę co 24 godziny',
        'Każde odebranie daje 100 punktów',
        'Punkty są mnożone przez Twój mnożnik',
    ],
    multiplierBonusesTitle: 'Bonusy mnożnika',
    multiplierBonusesRules: [
        'Zacznij z mnożnikiem 1x',
        'Połącz Telegram dla bonusu +10%',
        'Zweryfikuj email dla bonusu +10%',
        'Bonusy się sumują dla maksymalnych nagród',
    ],
    leaderboardTitle: 'Ranking',
    leaderboardRules: [
        'Rywalizuj z innymi graczami',
        'Ranking aktualizuje się w czasie rzeczywistym',
        'Najlepsi gracze otrzymują specjalne nagrody',
    ],
    boostEarningsTitle: 'Zwiększ zarobki',
    boostEarningsRules: [
        'Wykonuj wyzwania dla bonusów',
        'Dołącz do naszej społeczności Telegram',
        'Pozostań aktywny dla maksymalnych nagród',
    ],
    challenges: 'Wyzwania',
    telegramChallenge: 'Wyzwanie Telegram',
    emailChallenge: 'Wyzwanie Email',
    connectTelegram: 'Połącz Telegram',
    shareEmail: 'Udostępnij email',
    telegramSuccess: '🎉 Gratulacje! Otrzymujesz teraz stały bonus 10% do wszystkich nagród!',
    telegramPrompt:
        'Połącz swoje konto Telegram, aby otrzymać stały bonus 10% do wszystkich nagród!',
    emailSuccess: '🎉 Gratulacje! Otrzymujesz teraz stały bonus 10% do wszystkich nagród!',
    emailPrompt: 'Udostępnij swój email, aby otrzymać stały bonus 10% do wszystkich nagród!',
    connectEmail: 'Połącz email',
    cancel: 'Anuluj',
    emailPrivacy: 'Używamy Twojego emaila tylko do ważnych aktualizacji i powiadomień o nagrodach.',
    connectYourEmail: 'Połącz swój email',
    emailBonus: '🎉 Otrzymaj stały bonus 10% do wszystkich nagród, łącząc swój email!',
    enterValidEmail: 'Wprowadź prawidłowy adres email',
    emailAddress: 'Adres email',
    errorSavingEmail: 'Błąd podczas zapisywania emaila. Spróbuj ponownie.',
    claimButton: 'Odbierz',
    earnedReward: 'Zdobyta nagroda',
    rewardValue: '{{amount}} Punktów',
    claimingReward: 'Odbieranie...',
    claimSuccess: 'Pomyślnie odebrano {{amount}} punktów!',
    claimError: 'Odbieranie nie powiodło się. Spróbuj ponownie.',
    privacyDisclaimer:
        'Coinomi nie zbiera danych osobowych; system zewnętrzny bezpiecznie zarządza punktami i połączeniami społecznościowymi.',
    streakBonus: 'Bonus za serię',
    streakDays: '{{days}}/5 Dni',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Ekstra',
    streakDescription: 'Odbieraj przez 5 dni z rzędu dla maksymalnego bonusu',
    streakToday: 'Dziś',
    streakMissed: 'Pominięto',
    streakComplete: 'Ukończono',
    streakActive: 'Aktywna seria',
    streakLost: 'Utracona seria',
    streakNext: 'Następny',
    home: 'Strona główna',
    currentStreak: 'Obecna seria',
    totalClaims: 'Łączne odbiory',
    userStats: 'Twoje statystyki',
    referrals: 'Polecenia',
    referralProgram: 'Program poleceń',
    howReferralWorks: 'Jak działają polecenia:',
    referralSteps: [
        'Udostępnij swój link polecający znajomym',
        'Gdy dołączą przez Twój link, stają się Twoimi poleconymi',
        'Zdobywaj punkty bonusowe za każde aktywne polecenie',
        'Śledź swoje polecenia i zarobki tutaj',
    ],
    referralRewards: 'Przyznawane punkty za polecenia:',
    referralBonuses: [
        '100 punktów za polecenie',
        '10% wszystkich punktów zarobionych przez Twoich poleconych',
    ],
    yourReferralLink: 'Twój link polecający',
    copyToClipboard: 'Kopiuj do schowka',
    linkCopied: 'Link skopiowany do schowka!',
    totalReferrals: 'Łączne polecenia',
    yourReferralCode: 'Twój kod polecający',
    referralCodeCopied: 'Kod polecający skopiowany!',
    editReferralCode: 'Edytuj kod polecający',
    editReferralCodeInstructions:
        'Wybierz nowy kod polecający. Musi mieć minimum 5 znaków i może zawierać litery i cyfry.',
    newReferralCode: 'Nowy kod polecający',
    referralCodeRequirements: 'Minimum 5 znaków, tylko litery i cyfry',
    updating: 'Aktualizowanie...',
    update: 'Aktualizuj',
    referralCodeTaken: 'Ten kod polecający jest już zajęty',
    haveReferralCode: 'Masz kod polecający?',
    enterReferralCodePrompt: 'Jeśli ktoś Cię polecił, wprowadź tutaj ich kod, aby połączyć konta.',
    enterReferralCode: 'Wprowadź kod polecający',
    enterReferralCodeInstructions: 'Wprowadź kod polecający, który został z Tobą udostępniony.',
    referralCode: 'Kod polecający',
    referralCodeFormat: 'Tylko litery i cyfry',
    submitting: 'Wysyłanie...',
    submit: 'Wyślij',
    enterCode: 'Wprowadź kod',
    pleaseAddtoken: 'Dodaj parametr token do URL',
    authenticationError: 'Wystąpił błąd podczas uwierzytelniania',
    noUserFound: 'Nie znaleziono użytkownika',
    userNotFoundMessage: 'Nie można znaleźć danych użytkownika',
    backToHome: 'Powrót do strony głównej',
    retry: 'Spróbuj ponownie',
    baseMultiplier: 'Mnożnik podstawowy',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Wyzwanie poleceń',
    referralChallengePrompt:
        'Zaproś znajomych i zdobywaj punkty bonusowe! Otrzymaj 100 punktów za każde polecenie plus 10% ich zarobków.',
    startReferring: 'Zacznij polecać',
    referralSuccess: '🎉 Gratulacje! Pomyślnie poleciłeś użytkowników i zdobywasz punkty bonusowe!',
    unranked: 'Bez rankingu',
    noPlayersYet: 'Bądź pierwszym, który dołączy!',
    shareVia: 'Udostępnij przez',
    shareOn: 'Udostępnij na {{network}}',
    shareInviteText:
        '🚀 Zarabiam darmowe krypto z @CoinomiWallet!\n\nPobierz Coinomi z coinomi.com/downloads i wprowadź mój kod polecający {{referralCode}}, aby otrzymać bonus po dołączeniu do #Coinomi Rewards w aplikacji.',
    yourStatsThisWeek: 'Twoje statystyki w tym tygodniu',
    pointsMultiplier: 'Mnożnik punktów',
    yourRank: 'Twoja pozycja',
    rewards: 'Nagrody',
    daily: 'Dziennie',
    weekly: 'Tygodniowo',
    claimRewards: 'Odbierz nagrody',
    copy: 'Kopiuj',
    // Twitter Challenge
    twitterChallenge: 'Wyzwanie Twitter',
    connectTwitter: 'Połącz z Twitterem',
    twitterSuccess: '🎉 Gratulacje! Otrzymujesz teraz stały 10% bonus do wszystkich nagród!',
    twitterPrompt: 'Połącz swoje konto Twitter, aby otrzymać stały 10% bonus do wszystkich nagród!',
    pleaseAddUserId: 'Dodaj parametr userId do URL',
    emailChallengePrompt:
        'Udostępnij swój email, aby otrzymać stały bonus 10% do wszystkich nagród!',
    emailChallengeSuccess: '🎉 Połączono! Otrzymujesz teraz stały bonus 10% do wszystkich nagród!',
    followKoalaWalletChallenge: 'Śledź @coinomiWallet na Twitterze, aby nas wesprzeć!',
    twitterAuthSuccessTitle: 'Twitter pomyślnie połączony!',
    twitterAuthSuccessMessage:
        'Twoje konto Twitter zostało pomyślnie połączone. Możesz teraz kontynuować korzystanie z aplikacji.',
    continueToApp: 'Kontynuuj do aplikacji',
    twitter_like: 'Polubił tweet',
    twitter_retweet: 'Retweetował tweet',
    disconnect: 'Rozłącz',
    followCoinomiWallet: 'Obserwuj @coinomiWallet na Twitterze, aby nas wesprzeć!',
    connectedBonus: '🎉 Połączono! Otrzymujesz teraz stały 10% bonus na wszystkie nagrody!',
};
